import styled from 'styled-components';

export const SlideContainer = styled.div`
  width: 100%;
  position: relative;
  height: calc(100dvh - 48px);
`;

export const BottomButtonContainer = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 15px 24px;
  background-color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  position: absolute;
  bottom: 0px;
`;

export const TermsSlide = styled.div`
  width: 100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 28px;
`;

export const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
`;

export const SeperateLine = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme['warmgray-300']};
`;

export const TermsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const TermsItem = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;

  input {
    display: none;
  }
`;

export const TermsItemIconWrapper = styled.div<{ isActive: boolean }>`
  width: 24px;
  height: 24px;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    path {
      stroke: ${({ isActive, theme }) => (isActive ? theme['orange-primary'] : theme['orange-secondary'])};
    }
  }
`;

export const TermsItemAllCheckIconWrapper = styled.div<{ isActive: boolean }>`
  width: 24px;
  height: 24px;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    path {
      fill: ${({ isActive, theme }) => (isActive ? theme['orange-primary'] : theme['orange-secondary'])};
    }
  }
`;

export const TermsItemLinkIcon = styled.div`
  flex-shrink: 0;
  position: absolute;
  right: 20px;

  width: 16px;
  height: 16px;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme }) => theme['warmgray-300']};
    }
  }
`;
